// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../node_modules/emoji.css/dist/emoji.min.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import '../node_modules/vuetify/dist/vuetify.css'
import '../static/css/override.css'
import vuetify from 'vuetify'
import 'es6-promise/auto'
import store from './store/store'
import VueObserveVisibility from 'vue-observe-visibility'
import Snotify from 'vue-snotify'
import VueMq from 'vue-mq'
import DatetimePicker from 'vuetify-datetime-picker'
 

// load token if logged
store.commit('loadToken')
// check if a route needs login
router.beforeEach((to, from, next) => {
  if (to.path != '/admin') {
    if (to.query.rd != null) {
      next(to.query.rd)
    } else {
      // 404
      if (to.matched.length > 0) {
        // logged
        if (to.matched.some(record => record.meta.requiresAuth)) {
          // needs admin
          if (to.matched.some(record => record.meta.requiresAdmin)) {
            if (!store.getters.isAdmin) {
              next({
                path: '/admin/dashboard',
                query: {
                  msg: store.state.currentTranslator.getString('Non hai i permessi per accedere a questa risorsa')
                }
              })
            } else {
              next()
            }
          } else {
            if (!store.getters.isLogged) {
              next({
                path: '/admin/login',
                query: {
                  msg: store.state.currentTranslator.getString(
                    'Sessione scaduta, ti preghiamo di accedere di nuovo'
                  )
                }
              })
            } else {
              next()
            }
          }
        } else {
          next()
        }
      } else {
        next({
          path: '/admin/dashboard',
          query: {
            msg: store.state.currentTranslator.getString('Pagina non trovata')
          }
        })
      }
    }
  }
})

Vue.use(Snotify)
Vue.use(vuetify)
Vue.use(VueObserveVisibility)
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    xs: 600,
    sm: 960,
    md:1264,
    lg: 1904,
    xl: Infinity,
  }
});
Vue.config.devtools = true;
Vue.use(DatetimePicker)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js